// extracted by mini-css-extract-plugin
export default {"container":"blocked-wrapper_container__SaHDO"};